<template><App :keepAliveInclude="keepAliveInclude"/></template><script>
	// 导入辅助函数
	import {
		mapActions,
		mapState
	} from 'vuex';
	import {
		updateRecord,saveRecord,
		submitMessage
	} from './utils/api.js'
	export default {
		onLaunch: function(options) {
			// h5跑页面,此处固定传值
			uni.setStorageSync('tokenInfo', {
				access_token: '882ffdfa-6b4a-46c0-8763-ec59b2d68c0e',
				token_type: 'bearer',
				refresh_token: '3de39e1b-60a1-42c5-980e-68ca046dba8a',
				expires_in: 1829148,
				scope: 'all'
			});
			uni.setStorageSync('userInfo', {
				custId: 6010000041957,
				custType: 6,
				opername: '',
				mobile: '15972137065',
				tradePwd: '',
				name: 'T1648217954090881025',
				orgId: null,
				wxsOpenid: 'omE475Yj2f6ZUbFm21VTmG0Bu-Lc',
				zfbOpenid: '',
				nickName: 'T1648217954090881025',
				avatarUrl: '',
				gender: 1
			});
			// 获取手机信息
			uni.getSystemInfo({
				success: function(res) {
					if (res.errMsg.includes('ok')) {
						uni.setStorageSync('systemInfo', res);
					}
				}
			});
			const updateManager = uni.getUpdateManager();
			updateManager.onCheckForUpdate(function(res) {
				console.log('开始执行版本更新检测');
				// 请求完新版本信息的回调
				if (res.hasUpdate) {
					updateManager.onUpdateReady(function(res2) {
						uni.showModal({
							title: '更新提示',
							content: '发现新版本，是否重启应用?',
							cancelColor: '#cccccc',
							confirmColor: '#00aaff',
							success(res2) {
								if (res2.confirm) {
									// 新的版本已经下载好，调用 applyUpdate 应用新版本并重启
									console.log('重新更新版本');
									updateManager.applyUpdate();
								}
							}
						});
					});
				}
			});

			updateManager.onUpdateFailed(function(res) {
				// 新的版本下载失败
				uni.showModal({
					title: '提示',
					content: '检查到有新版本，但下载失败，请检查网络设置',
					success(res) {
						if (res.confirm) {
							// 新的版本已经下载好，调用 applyUpdate 应用新版本并重启
							updateManager.applyUpdate();
						}
					}
				});
			});
		},
		onShow: function(options) {
			console.log('执行了App')
		},
		onHide: function() {
		},
		methods: {}
	};
</script>

<style lang="scss">
	/* 注意要写在第一行，同时给style标签加入lang="scss"属性 */
	@import 'uview-ui/index.scss';

	.uni-color-primary {
		background-color: $uni-color-primary;
	}

	.uni-color-success {
		background-color: $uni-color-success;
	}

	.uni-color-warning {
		background-color: $uni-color-warning;
	}

	.uni-color-error {
		background-color: $uni-color-error;
	}

	.dark {
		background: #111730 !important;
		color: #ffffff !important;
	}

	.white {
		background: #e1ebf4 !important;
		color: #000000 !important;
	}
</style>